/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Plate } from "src/classes/plate/Plate";
import { HOTKEYS } from "src/components/Hotkeys/hotkeys";
import { useHotkey } from "src/lib/hooks/useHotkey";

export function usePlateShortcuts(plate: Plate): void {
  // Undo Redo
  useHotkey(HOTKEYS.UNDO, () => plate.onUndo());
  useHotkey(HOTKEYS.REDO, () => plate.onRedo());

  // Selection
  useHotkey(HOTKEYS.COMMAND_A, () => plate.selectAll(), [], { stopPropagation: true, preventDefault: true });
  useHotkey(HOTKEYS.ESCAPE, () => plate.deselectAll());

  // Arrow Keys
  useHotkey(HOTKEYS.ARROW_DOWN, () => plate.onArrowKey("down"), [], { preventDefault: true });
  useHotkey(HOTKEYS.SHIFT_ARROW_DOWN, () => plate.onArrowKey("down"), [], { preventDefault: true });
  useHotkey(HOTKEYS.ARROW_UP, () => plate.onArrowKey("up"), [], { preventDefault: true });
  useHotkey(HOTKEYS.SHIFT_ARROW_UP, () => plate.onArrowKey("up"), [], { preventDefault: true });
  useHotkey(HOTKEYS.ARROW_LEFT, () => plate.onArrowKey("left"), [], { preventDefault: true });
  useHotkey(HOTKEYS.SHIFT_ARROW_LEFT, () => plate.onArrowKey("left"), [], { preventDefault: true });
  useHotkey(HOTKEYS.ARROW_RIGHT, () => plate.onArrowKey("right"), [], { preventDefault: true });
  useHotkey(HOTKEYS.SHIFT_ARROW_RIGHT, () => plate.onArrowKey("right"), [], { preventDefault: true });

  //Delete
  useHotkey(HOTKEYS.BACKSPACE, () => plate.onBackspace());
}
